import React, { useEffect, useRef, useState } from "react";
import { Odd } from "../../../../models/Odd_response_model.tsx";
import { useBetContext } from "../../../../context/BetContext.tsx";
import {  formatNumber } from "../../../../helpers/functions.tsx";
import { BetDetails } from "../../../../models/MyBetModel.tsx";

export function SelectedOddCommercialLive({ o, onRequestBetsModal, currentBet, slotIndex }:
    { o: Odd, onRequestBetsModal: Function, currentBet?: BetDetails, slotIndex: number }) {

    const { deleteBet } = useBetContext();
    const [windowWidth] = useState(window.innerWidth);
    const [priceChange, setPriceChange] = useState<'up' | 'down' | ''>('');
    const prevPriceRef = useRef<number>(o.price);
    const [amount, setAmount] = useState<string>(o.price > 0 ? (currentBet?.bet ? String(currentBet.bet) : '') : (currentBet?.reward ? String(currentBet.reward) : ''));
    const isSubmittingRef = useRef(false);

    useEffect(() => {
        setAmount(
            o.price > 0
                ? (currentBet?.bet ? String(currentBet.bet) : '')
                : (currentBet?.reward ? String(currentBet.reward) : '')
        );
    }, [currentBet?.bet, currentBet?.reward, o.price]);

    function processBet(value: string) {
        const parsed = parseFloat(value);
        if (!value || isNaN(parsed) || parsed <= 0) {
            deleteBet(o.id);
            return;
        }

        onRequestBetsModal({
            ...currentBet,
            id_selection: o.id,
            betName: o.name,
            odd: o,
            reward: parsed
        }, false);
    }

    useEffect(() => {
        if (prevPriceRef.current !== o.price) {
            setPriceChange(o.price > prevPriceRef.current ? 'up' : 'down');
            prevPriceRef.current = o.price;

            const timeout = setTimeout(() => setPriceChange(''), 2000);
            return () => clearTimeout(timeout);
        }
    }, [o.price]);

    function buildControlForPrefix(): React.ReactNode {
        if (!o) return null;
        const priceClass = priceChange === 'up' ? 'price-up' : priceChange === 'down' ? 'price-down' : '';

        switch (slotIndex) {
            case 0:
                return (
                    <span className={`betOveU ${priceClass}`}>
                        {formatNumber(o.points, undefined, "points")} {formatNumber(o.price)}
                    </span>
                );
            case 1:
                return (
                    <span className={`betOveU ${priceClass}`}>
                        {formatNumber(o.price)}
                    </span>
                );
            case 2: {
                if (!o.selection_line) return null;
                const isOver = o.selection_line.toLowerCase() === 'over';
                return (
                    <>
                        <span className="under-texbox">{windowWidth <= 960 ? (isOver ? 'O' : 'U') : (isOver ? 'Over' : 'Under')}</span>
                        <span className={`betOveU ${priceClass} ${isOver ? 'adjust-price-total-o' : 'adjust-price-total-u'}`}>
                            {formatNumber(o.price)}
                        </span>
                        {isOver && <span className="prefix-betPoint-total">{formatNumber(o.points, undefined, "unsigned")}</span>}
                    </>
                );
            }
            case 3: {
                const isOver = o.selection_line.toLowerCase() === 'over';
                return (
                    <>
                        <span className={isOver ? 'over-texbox' : 'under-texbox'}>
                            {windowWidth <= 960 ? (isOver ? 'O' : 'U') : (isOver ? 'Over' : 'Under')}
                        </span>
                        {!isOver && <span className="prefix-betPoint">{formatNumber(o.points, undefined, "unsigned")}</span>}
                        <span className={`betOveU ${priceClass}`}>{formatNumber(o.price)}</span>
                    </>
                );
            }
            default:
                return null;
        }
    }

    return (
        <>

            <div className={`${"large-screen"} ${o.selection_line}`}>
                <div className="future-container-name">
                    {o && (
                        <label
                            className={`select-box ${priceChange === "up" ? "price-up" : priceChange === "down" ? "price-down" : ""}`}
                            onClick={(e) => {
                                e.preventDefault();
                                onRequestBetsModal({
                                    ...currentBet,
                                    id_selection: o.id,
                                    betName: o.name,
                                    odd: o,
                                    reward: 0,
                                }, true)
                            }}
                        >
                            {`${formatNumber(o.points, o.selection_line, "points")} ${formatNumber(o.price)}`}
                        </label>
                    )}
                </div>
                <div className="input-container-bet">
                    <input
                        type="text"
                        className="textbox"
                        value={amount}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!/^\d*$/.test(value)) return;

                            setAmount(value);
                        }}
                        onBlur={(e) => {
                            if (isSubmittingRef.current) {
                                isSubmittingRef.current = false;
                                return;
                            }
                            processBet(e.target.value);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                isSubmittingRef.current = true;

                                const parsed = parseFloat(amount || '0');

                                onRequestBetsModal({
                                    ...currentBet,
                                    id_selection: o.id,
                                    betName: o.name,
                                    odd: o,
                                    reward: parsed
                                }, true);
                            }
                        }}
                    />
                </div>
            </div>

            <label className={`small-screen ${currentBet?.id_selection === o.id ? 'selected' : ''}  ${o.market_id === 'total' ? 'total-odd' : ''}`}
                onClick={(e) => {
                    e.preventDefault();
                    currentBet?.id_selection === o.id
                        ? deleteBet(o.id)
                        : onRequestBetsModal(
                            {
                                ...currentBet,
                                id_selection: o.id,
                                betName: o.name,
                                odd: o,
                                reward: 0,
                            },
                            true
                        )
                }}
            >
                {buildControlForPrefix()}
            </label>

        </>
    );
}